import React, { useState, useEffect } from "react";
import axios from "axios";

import RTBListFirstTable from "../RTBListComponents/RTBListFirstTable";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Lottie from "lottie-react";

import reloadpage from "../../reloadpage.json";

var SendDataToFirstTable = [];
var ObjSendDataToFirstTable = {};

export default function RTBList() {
  const [isClicked, setIsClicked] = useState(false);

  const items = localStorage.getItem("Token");
  const trimmedMyaa = items.substring(1, items.length - 1);
  const aa = trimmedMyaa.replace("?jwt=", "");
  const [Seat, setSeat] = useState("1");
  const handleChangeSeat = (event) => {
    setSeat(event.target.value);
  };
  const [Loading, setLoading] = useState(true);

  const GetSearchRtb = async (event) => {
    SendDataToFirstTable = [];
    setLoading(false);
    var newObj = {
      environment: "mobile_app",
      seatId: Seat,
    };
    try {
      const response = await axios.post(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/SearchRtbMngm`,
        newObj,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
        }
      );
      console.log(response.data);
      for (let i = 0; i < response.data.length; i++) {
        ObjSendDataToFirstTable = {
          seatName: response.data[i].seatName,
          campaignId: response.data[i].campaignId,
          campaignName: response.data[i].campaignName,
          seatId: response.data[i].seatId,
          fillRateOp: response.data[i].fillRateOp,
          inappRtbCap: response.data[i].inappRtbCap,
          AvgQPS: "",
        };
        SendDataToFirstTable.push(ObjSendDataToFirstTable);
      }
      console.log(SendDataToFirstTable);
      setLoading(true);
    } catch (error) {
      console.log("error in GetSearchRtb");
    }
  };
  const receiveDataFromChildForDelete = (data) => {};

  const receiveDataFromChild = (data) => {};
  return (
    <div>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box sx={{ minWidth: 120 }}>
          <FormControl fullWidth sx={{ width: "250px" }}>
            <InputLabel id="demo-simple-select-label">Seat*</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={Seat}
              label="Seat*"
              onChange={handleChangeSeat}
            >
              <MenuItem value={"1"}>O2R</MenuItem>
              <MenuItem value={"3"}>Shauking</MenuItem>
              <MenuItem value={"4"}>Oshi</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <button
          style={{
            border: "none",
            background: "white",
            cursor: "pointer",
            minWidth: 60,
          }}
          onClick={() => {
            GetSearchRtb();
            setIsClicked(true);
            setTimeout(() => setIsClicked(false), 1000);
          }}
        >
          <Lottie
            loop={isClicked ? true : false}
            autoplay={isClicked ? true : false}
            animationData={reloadpage}
            rendererSettings={{
              preserveAspectRatio: "xMidYMid slice",
              display: "flex",
              background: "white",
              borderRadius: 100,
              justifyContent: "center",
              alignItems: "center",
              margin: 3,
              paddingRight: 5,
              height: 40,
              width: 60,
              minWidth: 60,
            }}
            isPaused={isClicked}
          />
        </button>
      </div>
      {Loading ? (
        <>
          <RTBListFirstTable
            onSendDataForDelete={receiveDataFromChildForDelete}
            onSendData={receiveDataFromChild}
            SendDataToFirstTable={SendDataToFirstTable}
          />
        </>
      ) : (
        <>Ladong...</>
      )}
    </div>
  );
}
